import { Routes } from '@angular/router';
import { mainLayoutRoutes } from './@commons/layouts/main-layout.routes'; // Import Routes from Angular Router
import { GuidesHostGuard } from './@commons/guards/guides-host.guard';
import { NavigationGuard } from './@commons/guards/navigation.guard';

// Define application routes using lazy loading for feature modules
export const routes: Routes = [
  {
    path: 'onboarding', // Path for onboarding
    loadChildren: () => import('./onboarding/onboarding.routes'), // Lazy load onboarding routes
  },
  {
    path: 'auth', // Path for authentication module
    loadChildren: () => import('./auth/auth.routes'), // Lazy load authentication routes
  },
  {
    path: 'oauth2', // Path for authentication module
    loadChildren: () => import('./auth/oauth2.routes'), // Lazy load authentication routes
  },
  {
    path: 'init', // Path for the welcome page
    loadChildren: () => import('./welcome/welcome.routes'), // Lazy load welcome routes
  },
  {
    path: 'article/:articleUid', // Path for article module
    loadComponent: () => import('./article/article.component').then((m) => m.ArticleComponent), // Lazy load article routes
  },
  {
    path: 'qr/plant/:uid', // Public page for QR code fallback
    loadComponent: () => import('./qr/plant-landing/plant-landing.component').then((m) => m.PlantLandingComponent),
  },
  {
    path: 'guides', // Public PDF culture guide builder (#208/#210)
    loadComponent: () => import('./guides/guides.component').then((m) => m.GuidesComponent),
  },
  {
    path: 'feedback', // Path for feedback module
    loadComponent: () => import('./feedback/feedback.component').then((m) => m.FeedbackComponent), // Lazy load feedback routes
  },
  {
    path: 'season-plan', // Mon plan de saison (NF-1), plein écran hors de la barre d'onglets
    loadComponent: () => import('./season-plan/season-plan.component').then((m) => m.SeasonPlanComponent),
    canActivate: [NavigationGuard],
  },
  {
    path: 'feu-vert', // Feu vert (NF-2) : liste et fiche verdict, plein écran hors de la barre d'onglets
    loadChildren: () => import('./green-light/green-light.routes'),
    canActivate: [NavigationGuard],
  },
  {
    path: 'confier', // Confier mon potager (NF-3) : liens du remplaçant, plein écran hors de la barre d'onglets
    loadComponent: () => import('./garden-handover/garden-handover.component').then((m) => m.GardenHandoverComponent),
    canActivate: [NavigationGuard],
  },
  {
    path: 'confie/:token', // Page publique du remplaçant (NF-3) : sans compte, sans garde ni barre du bas
    loadComponent: () =>
      import('./garden-handover/handover-sheet/handover-sheet.component').then((m) => m.HandoverSheetComponent),
  },
  {
    path: 'plante/:token', // Page publique d'une plante partagée (NF-6) : sans compte, sans garde ni barre du bas
    loadComponent: () =>
      import('./plant-share/plant-share-page/plant-share-page.component').then((m) => m.PlantSharePageComponent),
  },
  {
    path: 'notifications',
    loadComponent: () => import('./notifications/notifications.component').then((m) => m.NotificationsComponent),
  },
  {
    path: '', // On a "guides" subdomain (guides.vegiwise.com), render the public guide builder at the root
    canMatch: [GuidesHostGuard],
    loadComponent: () => import('./guides/guides.component').then((m) => m.GuidesComponent),
  },
  {
    path: '',
    redirectTo: 'home', // Default route redirects to 'home' (app.vegiwise.com unchanged)
    pathMatch: 'full',
  },
  ...mainLayoutRoutes, // Include main layout routes here
  {
    path: 'garden', // Path for potager routes
    loadChildren: () =>
      import('./garden/garden.module').then((m) => m.GardenModule), // Ensure correct import path
  },
  {
    path: '**',
    redirectTo: 'home', // Global fallback route to splashScreen
  },
];
